"use client";

import Icon from "@repo/ui/components/ui/icon/icon";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import Chip from "@repo/ui/components/ui/chip";
import { useEffect, useState } from "react";
import Link from "next/link";
import { useLocalStorage } from "@repo/next-shared/utils/hooks";
import { Session } from "next-auth";
import { cn } from "@repo/ui/lib/utils";
import AlgoliaSearch from "@components/search/algolia-search";
import { searchQueryUrl } from "@/algolia/search-url";

export default function Search({ session }: { session: Session | null }) {
  const t = useTranslations();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const defaultSearches = [
    "Adidas",
    "Sneakers",
    "Iuter",
    "Dickies",
    "New Balance",
    "Jeans",
    "Felpa",
    "Phobia",
  ];
  const [recentSearches, setRecentSearches] = useLocalStorage<string[]>(
    "recent-searches",
    [],
  );
  const router = useRouter();
  function navigateToResults(search: string) {
    if (!recentSearches.includes(search) && search !== "") {
      setRecentSearches((prev) => [search, ...prev].slice(0, 4));
    }
    router.push(searchQueryUrl(search));
  }

  function onSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const search = String(formData.get("search") ?? "");
    navigateToResults(search);
  }

  return (
    <div
      className={cn(
        "relative pt-[6.5rem] flex-col flex items-center justify-center",
        "group max-md:has-[input:focus]:-translate-y-[60px] max-md:has-[input:focus]:pt-0 scroll-smooth transition duration-300 ease-in-out",
      )}
    >
      <Icon
        className="absolute cursor-pointer h-[40px] w-[40px] top-[0px] right-[0px] max-md:h-[30px] max-md:w-[30px] max-md:top-[4px] max-md:right-[4px]"
        icon="Close"
        onClick={router.back}
      />
      <div className="w-full max-w-[700px] min-w-[360px] flex flex-col items-center justify-center text-center">
        <h1 className="leading-[120%] tracking-[-0.5px]">
          {t("Search.title")}
        </h1>
        <AlgoliaSearch
          onSearch={onSearch}
          onSuggestionSelect={navigateToResults}
        />
        <h3 className="mt-10 max-md:group-has-[input:focus]:mt-5">
          {t(session ? "Search.last_search" : "Search.popular_search")}
        </h3>
        <div className="*:min-w-40 my-5 font-bold grid grid-flow-row grid-cols-4 max-md:grid-cols-2 gap-5 max-md:group-has-[input:focus]:gap-3">
          {mounted &&
            (session
              ? recentSearches && recentSearches.length > 0
                ? [...recentSearches, ...defaultSearches].slice(0, 4)
                : defaultSearches
              : defaultSearches
            ).map((recentSearch, i) => (
              <Link key={i} href={searchQueryUrl(recentSearch)}>
                <Chip className="overflow-hidden text-ellipsis whitespace-nowrap">
                  {recentSearch.slice(0, 16)}
                  {recentSearch.length > 16 && "..."}
                </Chip>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
}
